var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsecases(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 917 541",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #293130;\n      }\n\n      .cls-1,\n      .cls-2,\n      .cls-3,\n      .cls-4 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #1e2524;\n      }\n\n      .cls-3 {\n        fill: #272a2e;\n      }\n\n      .cls-4 {\n        fill: #424769;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 44,
    width: 122,
    height: 497,
    rx: 27.53,
    ry: 27.53
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 159,
    y: 128,
    width: 122,
    height: 413,
    rx: 27.53,
    ry: 27.53
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 318,
    y: 247,
    width: 122,
    height: 294,
    rx: 27.53,
    ry: 27.53
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 477,
    y: 82,
    width: 122,
    height: 459,
    rx: 27.53,
    ry: 27.53
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 636,
    width: 122,
    height: 541,
    rx: 27.53,
    ry: 27.53
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 795,
    y: 152,
    width: 122,
    height: 389,
    rx: 27.53,
    ry: 27.53
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsecases);
export default __webpack_public_path__ + "static/media/usecases.72544f13c7acb7e8af5a80286a279e25.svg";
export { ForwardRef as ReactComponent };